import { render, staticRenderFns } from "./dataVieweight.vue?vue&type=template&id=bc5f37d4&scoped=true"
import script from "./dataVieweight.vue?vue&type=script&lang=js"
export * from "./dataVieweight.vue?vue&type=script&lang=js"
import style0 from "./dataVieweight.vue?vue&type=style&index=0&id=bc5f37d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5f37d4",
  null
  
)

export default component.exports